import { FeedbackVariant } from "ds/components/Feedback/types";
import { BurstVerdict } from "shared/Usage/utils";
import { WorkerUsageBurst } from "types/generated";

export const USAGE_WORKERS_PATH = "/settings/usage/workers";

type BurstCalloutVerdict = Extract<BurstVerdict, "approaching" | "over">;

type BurstCalloutBudget = Pick<WorkerUsageBurst, "budgetMinutes" | "usedMinutes">;

type BurstCalloutContent = {
  variant: FeedbackVariant;
  storageKeyPrefix: string;
  getTitle: (burst: BurstCalloutBudget) => string;
  body: string;
};

export const BURST_CALLOUT_CONTENT: Record<BurstCalloutVerdict, BurstCalloutContent> = {
  approaching: {
    variant: "warning",
    storageKeyPrefix: "burst-warning",
    getTitle: ({ budgetMinutes, usedMinutes }) =>
      `You have used ${Math.floor((usedMinutes / budgetMinutes) * 100)}% of your included burst minutes`,
    body: "Once you pass 100%, additional costs may be incurred. Your services will not degrade in any way. You can track this as your burst budget on the usage page.",
  },
  over: {
    variant: "danger",
    storageKeyPrefix: "burst-overage",
    getTitle: () => "You have used 100% of your included burst minutes",
    body: "Additional costs may be incurred for the rest of this billing cycle. Your services will not degrade in any way. You can track this as your burst budget on the usage page.",
  },
};
